<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content"
           v-loading="loadingStaus"
           :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>姓名</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.realname }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>身份证号</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.idcard }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>地址</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.address }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>手机号</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.mobile }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>规格</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.specs }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>类目</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.category_name }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>单位</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.unit }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>数量</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.number }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>额度</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.money }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>税号</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.taxpayer }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>开户行</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.bank }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>银行卡</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.bank_card }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>公司电话</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.company_mobile }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>公司名称</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.company_name }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>公司地址</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.company_address }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>身份证正反面照片</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">
                <div v-if="this.$route.query.idCardArr.length>0">
                  <img class="showImg" :key="index" v-for="(item,index) in this.$route.query.idCardArr" :src="item">
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>发票实拍</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">
                <img class="showImg" :src="this.$route.query.express_img">
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>合同</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light" v-if="Array.isArray(this.$route.query.contract_urls)">
                <div v-if="this.$route.query.contract_urls.length>0">
                  <img class="showImg" :key="index" v-for="(item,index) in this.$route.query.contract_urls" :src="item">
                </div>
              </div>
              <div class="grid-content bg-purple-light" v-else>
                <div>
                  <img class="showImg" :key="index" :src="this.$route.query.contract_urls">
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>转账凭证</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light" v-if="Array.isArray(this.$route.query.evidence_urls)">
                <div v-if="this.$route.query.evidence_urls.length>0">
                  <img class="showImg" :key="index" v-for="(item,index) in this.$route.query.evidence_urls" :src="item">
                </div>
              </div>
              <div class="grid-content bg-purple-light" v-else>
                <div>
					<img class="showImg" :key="index" :src="this.$route.query.evidence_urls">
                </div>
            </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-white"><span>状态</span></div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple-light">{{ this.$route.query.alias_status }}</div>
            </el-col>
          </el-row>


        </el-row>
        <!-- 预览图片弹框 -->
        <el-dialog
          :title="'预览图片'"
          :visible.sync="dialogVisible"
          :modal="false"
          :width="'25%'"
        >
          <div class="block" v-if="dialogVisible">
            <img :src="this.imageUrl" class="preview">
          </div>
        </el-dialog>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import {mapGetters} from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    UploadFile,
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      billId: 0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps: {
        label: 'display_name',
        value: 'id',
      },
      detailData: {},
      // 分类列表
      categoryList: [],
      openapiList: [],
      // 标签
      categoryLabelList: [],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList: [],
      // 已选中标签
      selectedLabelList: [],
      //详情数据
      companyList: {},
      // 公司基本信息表单结构
      formData: {
        file_url: '',
        status: 0
      },
      // 已上传图片列表
      uploadFileList: [],
      // 公司基本信息规则
      rules: {
        name: [
          {required: true, message: '输入公司名称', trigger: 'blur'},
        ],
        file_url: [
          {required: true, message: '输入文件名称', trigger: 'blur'},
        ]
      },
      // 附件类型
      attachmentType: ['application/pdf', 'application/caj', '', 'application/zip', 'application/rar', 'application/doc'],
      // 已上传附件列表
      attachmentUploadFileList: [],
      imageUrl: '',//图片地址
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    /* 预览图片 */
    showImage(data) {
      this.dialogVisible = true;
      this.imageUrl = data;
      console.log(data, "11111111111111")
    },
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename}) {
      console.log("->上传成功....", url, filename);
      this.formData.file_url = url
      console.log("formData", this.formData)
    },
    // 返回列表
    returnList() {
      this.$router.push('/bill')
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v)
      if (v) {
        this.formData.parent_id = v
      }
    },
    openapiChange(v) {
      console.log("openapiChange", v)
      if (v) {
        this.formData.openapi_id = v
      }
    },
    // 级联菜单组件change事件
    cascaderLabelChange(v) {
      if (v.length) {
        this.formData.category_2_id = v[(v.length - 1)]
        this.formData.category_2_ids = v
      } else {
        this.formData.category_2_id = ''
        this.formData.category_2_ids = []
      }
    },
    // 级联菜单自定义验证，选择分类
    cascaderVerify(rule, value, callback) {
      if (rule.required && !this.selectedList.length) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true
      console.log("formData -> ", this.formData);
      try {
        let id = await this.$api.saveBill(this.formData)
        if (id.length > 0) {
          this.$notify.success('保存成功！')
          if (this.billId === 0 && id) {
            this.$router.push(this.$route.matched[1].path)
          }
        }
        this.$nextTick(() => {
          this.loadingStaus = false
        })
      } catch (err) {
        console.log('err is ->', err)
      }
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.cover = 0
      this.uploadFileList = fileList
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment = 0
      this.attachmentUploadFileList = fileList
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    },
    // 初始化公司基本信息
    async init() {
      let url = this.$route.path
      let urlSlashCount = url.split('/').length
      this.action = url.split('/')[urlSlashCount - 1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      console.log("action -> ", this.formDisabled)
      if (this.$route.params.customer_id) {
        this.id = this.$route.params.customer_id
      }
      if (this.id) {
        let {info} = await this.$api.getCustomerInfo(this.id)
        console.log("formData", info)
        this.formData = info
      }
    },
    //返回上一页
    goBack() {
      this.$router.push({path: "/customer"});
    }
  },
  async mounted() {
    console.log(this.$route.query, '++++++++++++++++++++返回的数据')
    this.loadingStaus = true
    this.init()
    this.$nextTick(() => {
      this.loadingStaus = false
    })
  },
}
</script>

<style lang="stylus" scoped>
.showImg {
  margin-right 20px
  width 150px
  height auto
}

.main-page-content h2 {
  margin-left 50px
}

.bg-white {
  font-size 14px
  text-align center
  line-height: 36px;
  background-color #ffffff
  margin-right 20px
}

.bg-purple-light {
  font-size 14px
  text-align left
  line-height: 36px;
  background-color #ffffff
  border 1px solid #f4f3f3
  padding-left 20px
}
</style>
